import styled, { css } from 'styled-components';

export const PaginationWrapper = styled.div<{ isMobile: boolean }>`
  ${(props) =>
    props.isMobile &&
    css`
      width: 100%;
      order: -1;
      justify-content: center;
      display: flex;
    `};
`;
